import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/caasm/$')({
  beforeLoad: () => {
    throw redirect({ to: window.location.pathname.split('/')?.toSpliced(2, 1, 'assets').join('/'), search: true });
  },
});
